import { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterChip from "./FilterChip";

const availableFilters = {
    dateFrom: { type: "date" },
    dateTo: { type: "date" },
    brand: { type: "dropDown", items: ["Lehti A", "Lehti B"] },
    views: { type: "range", scale: [1, 5000], default: 2000 },
    test: { type: "int", default: 30 },
    person: { type: "text" },
    location: { type: "text" },
};

export default function QueryFilters({ filterOptions, filters, setFilters }) {
    const addFilter = () => setFilters([...filters, { name: null, value: "" }]);

    const updateFilter = (index, name, value) => {
        const newFilters = [...filters];
        newFilters[index] = { name, value };
        setFilters(newFilters);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };

    return (
        <Box display="flex" gap={1} flexWrap="wrap" mt={0}>
            {filters.map((filter, index) => (
                <FilterChip
                    key={index}
                    filterKey={filter.name}
                    availableFilters={filterOptions}
                    value={filter.value}
                    setValue={(name, value) => updateFilter(index, name, value)}
                    removeFilter={() => removeFilter(index)}
                />
            ))}

            {/* Add Filter Button */}
            <Tooltip title="Lisää suodatin" placement="top">
                <IconButton
                    onClick={addFilter}
                    color="primary"
                    sx={{
                        py: "14px"
                    }}
                >
                    {
                        filters && filters.length === 0 &&
                        <span style={{ fontSize: "0.8em" }}>Lisää &nbsp;</span>
                    }
                    <AddIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
}